export function initializeVideoCarousel(){
    $(".video__carousel-container").slick({
        lazyLoad: 'ondemand',
        rows: 0,
        arrows: true,
        variableWidth: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    });
}